import styled from "styled-components";

export const FacilityInfoStyled = styled.div``;
